import { Injectable } from '@angular/core';
import { catchError, retry } from 'rxjs/internal/operators';
import { Observable, throwError } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';
import { GlobalSearchService } from '../services/globalsearchservice.service';
@Injectable({
	providedIn: 'root'
})

export class ArchiveService {
	key = 'UET6DFMPAXW7BKCB';
	config: any;
	user: any = [];
	package: any = '';
	constructor(private http: HttpClient, private _configSvc: RuntimeConfigLoaderService, public globalSearchService: GlobalSearchService) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		})

		this.globalSearchService.user.subscribe((result) => {
			this.user = result;
		});

	}

	public httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
		})
	};

	public getOptions = {
		headers: new HttpHeaders({

		})
	};



	public getArchivedCustomerTrialBalance() {
		const method = 'archive/customers';
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public getArchivedDates() {
		const method = 'archive/customersdates';
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public getArchivedInventoryDates() {
		const method = 'archive/inventorydates';
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}



	public getArchivedCustomerbyDay(data: any) {
		const method = 'archive/customers';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(catchError(this.handleError(method, data)));
	}

	public getArchivedInventoryByDay(data: any) {
		const method = 'archive/inventory';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(catchError(this.handleError(method, data)));
	}

	public getStatementArchives() {
		const method = 'statements/archives';
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public downloadStatementArchive(data: any) {
		const method = 'statements/archivedownload';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(catchError(this.handleError(method, data)));
	}

	public getStatementArchiveSchedule() {
		const method = 'statements/archiveschedule';
		return this.http.get(this.setEndPoint(method), this.getOptions);
	}

	public saveStatementArchiveSchedule(data: any) {
		const method = 'statements/archiveschedulesave';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(catchError(this.handleError(method, data)));
	}

	public runStatementArchive(data: any) {
		const method = 'statements/archiverun';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(catchError(this.handleError(method, data)));
	}

	private setEndPoint(method: any) {
		return this.getApi() + method + this.getApiKey()
	}

	private getApi() {
		return this.config.apiServer.endpoint;
	}

	private getApiKey() {
		return '&key=' + this.config.apiCredentials.clientId + '&userid=' + this.user.user.userid + this.getPackage();
	}

	private getPackage() {
		const p = this.globalSearchService.getSessionItem('package');
		if(p) {
			return '&package='+p;
		} else {
			return '';
		}
	}

	public getKey() {
		return '&apikey=' + this.key;
	}

	private handleError<T>(operation = 'operation', result?: T) {

		return (error: any): Observable<T> => {

			if (error instanceof HttpErrorResponse && error.status === 401) {
				window.location.href = '/#/auth/logout';
			}

			return throwError(() => error);
		};
	}

}
